import { KalkulatorVhkComponent } from './kalkulator-vhk.component';
import vcRecaptcha from 'angular-recaptcha';
export const KalkulatorVhkModule = angular
	.module('kalkulatorVhk', [vcRecaptcha])
	.component('kalkulatorVhk', KalkulatorVhkComponent)
	.name;




// WEBPACK FOOTER //
// ../source/application/kalkulator/kalkulator-vhk/kalkulator-vhk.module.js